const nav = {
  "nav.language": "Language",
  "nav.dashboard": "Panel",
  "nav.myProfile": "My profile",
  "profile.editProfile": "Edit profile",
  "profile.designedBy": "Designed by",
  "site.manageProfile.requiredNote": "Fields marked * are required",
  "manageProfile.section.basic": "Basic info",
  "manageProfile.section.photo": "Profile photo",
  "manageProfile.section.social": "Social networks",
  "manageProfile.social.toggle": "Add social network links",
  "manageProfile.social.optional": "optional",
  "manageProfile.account.displayName.label": "Enter your name or designer name",
  "manageProfile.account.displayName.placeholder": "Your designer name",
  "manageProfile.account.email.label": "Email address",
  "manageProfile.account.email.placeholder": "you@example.com",
  "manageProfile.account.bio.label": "Tell us about yourself",
  "manageProfile.account.bio.placeholder": "Describe your style and projects...",
  "manageProfile.account.country.label": "Country",
  "manageProfile.account.becomeCreator.label": "Become a creator",
  "manageProfile.account.handle.label": "Profile handle",
  "manageProfile.account.handle.placeholder": "Unique identifier (e.g. my-profile)",
  "manageProfile.social.website.label": "Website",
  "manageProfile.social.website.placeholder": "https://your-site.com",
  "manageProfile.social.instagram.label": "Instagram profile",
  "manageProfile.social.instagram.placeholder": "@yourprofile",
  "manageProfile.social.facebook.label": "Facebook profile",
  "manageProfile.social.facebook.placeholder": "facebook.com/yourprofile",
  "manageProfile.social.youtube.label": "YouTube account",
  "manageProfile.social.youtube.placeholder": "youtube.com/@yourchannel",
  "manageProfile.saveChanges": "Save changes",
  "profile.page.title": "My profile",
  "profile.page.subtitle": "Sharing information about you helps visitors get to know your style!",
  "profile.nav.myPatterns": "My patterns",
  "profile.nav.addPattern": "Add new pattern",
  "profile.nav.creatorPortal": "Creator portal",
  "profile.nav.purchaseHistory": "Purchase history",
  "profile.country.poland": "Poland",
  "profile.country.germany": "Germany",
  "profile.country.france": "France",
  "profile.country.unitedKingdom": "United Kingdom",
  "profile.country.usa": "USA",
  "profile.country.other": "Other",
  "profile.patterns.lowestPriceNote": "Lowest price in the last 30 days before discount: {price}",
  "nav.profiles": "Profiles",
  "nav.descriptionpatternpage": "Description",
  "nav.otherpatternpage": "Other patterns of seller",
  "nav.similarpatternpage": "Similar patterns that may interest you",
  "nav.aboutdesigner": "About the designer",
  "nav.comments": "Comments",
  "nav.opinions": "Opinions",
  "nav.commentsrating": "Rating",
  "nav.woman": "Woman",
  "nav.man": "Man",
  "nav.girl": "Girl",
  "nav.boy": "Boy",
  "nav.newin": "New In",
  "nav.sale": "Sale",
  "nav.newseason": "New Season",
  "nav.newcollection": "New Collection",
  "nav.register": "Register",
  "register.page.title": "Register",
  "register.page.subtitle": "Join the Sew Light community",
  "register.conditions.part1": "By registering, you confirm that you have read ",
  "register.conditions.termsLink": "the terms and conditions",
  "register.conditions.part2": " and accept the ",
  "register.conditions.serviceTermsLink": "service terms",
  "register.conditions.part3": " and the ",
  "register.conditions.privacyPolicyLink": "privacy policy",
  "register.conditions.part4": ".",
  "register.errors.passwordMismatch": "Passwords do not match",
  "register.form.username.placeholder": "Username",
  "register.form.email.placeholder": "Email",
  "register.form.password.placeholder": "Password",
  "register.form.password2.placeholder": "Repeat password",
  "register.form.newsletterConsent": "I agree to receive commercial information by email...",
  "register.form.admin.label": "Admin",
  "register.form.suspend.label": "Suspend",
  "register.form.suspendReason.placeholder": "Suspend reason",
  "register.form.ban.label": "Ban",
  "register.form.banReason.placeholder": "Ban reason",
  "register.button.edit": "Edit",
  "register.button.submit": "Register",
  "nav.thumpnailsDesignerTitle": "Top rated designers in the category of ",
  "nav.sorting": "Sorting",
  "nav.latestSort": "Latest",
  "nav.priceSort": "Price",
  "nav.ratedSort": "Recommended",
  "patterns.filters.title": "Filters",
  "patterns.filters.clearAll": "Clear all",
  "patterns.filters.clearFilters": "Clear filters",
  "patterns.filters.found": "Patterns: {count}",
  "patterns.results.short": "{count} results",
  "patterns.noResults.title": "No patterns found",
  "patterns.noResults.message": "Try adjusting your filters or search terms.",
  "patterns.error.title": "We're sorry we can't display patterns right now",
  "patterns.search.placeholder": "Search patterns",
  "home.shopByStyle.title": "Shop by style",
  "home.shopByStyle.female": "Female",
  "home.shopByStyle.male": "Male",
  "home.shopByStyle.girl": "Girl",
  "home.designers.benefit.1.title": "Earn as much as you want",
  "home.designers.benefit.1.subtitle": "Set your own price and sell as many patterns as you want",
  "home.designers.benefit.2.title": "You can count on us",
  "home.designers.benefit.2.subtitle": "We will help you start earning from your own patterns.",
  "home.designers.benefit.3.title": "Build your community",
  "home.designers.benefit.3.subtitle": "Sewlight is the platform that connects designers big and small.",
  "home.designers.benefit.4.title": "Get discounts",
  "home.designers.benefit.4.subtitle": "Members receive discounts on other designers' patterns.",
  "home.designers.benefit.5.title": "Stay worry-free",
  "home.designers.benefit.5.subtitle": "We handle the platform and paperwork so you can focus on designing.",
  "home.designers.steps.register": "Register",
  "home.designers.steps.register.sub": "Create your account and become our member",
  "home.designers.steps.createProfile": "Create your profile",
  "home.designers.steps.createProfile.sub": "Add product photos and descriptions.",
  "home.designers.steps.addPatterns": "Add your patterns",
  "home.designers.steps.addPatterns.sub": "Upload your pattern as a PDF file",
  "home.designers.steps.setPrice": "Set your pattern price",
  "home.designers.steps.setPrice.sub": "Decide how many patterns to sell and at what price",
  "home.designers.steps.startEarning": "Start earning",
  "home.designers.steps.startEarning.sub": "Sell patterns at your own price",
  "legal.privacy.title": "Privacy Policy, GDPR and personal data protection for {platform}",
  "legal.creator.title": "Creator cooperation terms for {platform}",
  "legal.newsletter.title": "Newsletter terms for {platform}",
  "legal.omnibus.title": "How the Omnibus directive works in this app",
  "legal.omnibus.backLink": "Back to pattern editing",
  "legal.privacy.link": "privacy policy",
  "legal.platform.title": "Service terms",
  "legal.platform.subtitle": "Before you register, please read the service terms.",
  "legal.platform.side.regulamin": "Platform terms of service",
  "legal.platform.side.privacy": "Privacy policy, GDPR and personal data protection",
  "legal.platform.side.designers": "Creator cooperation terms",
  "legal.platform.side.newsletter": "Newsletter terms",
  "favourites.sort.label": "Sorting",
  "favourites.page.title": "Favourite patterns",
  "favourites.sort.recent": "Recently added favourites",
  "favourites.sort.difficultyAsc": "Difficulty: easy -> hard",
  "favourites.sort.difficultyDesc": "Difficulty: hard -> easy",
  "favourites.search.placeholder": "Search favourite patterns",
  "favourites.fetchError": "Failed to load favourite patterns.",
  "favourites.empty.title": "No favourite patterns yet",
  "favourites.empty.message": "Add patterns to your favourites to see them here.",
  "favourites.filtered.empty.title": "No results for selected filters",
  "favourites.filtered.empty.message": "Change filters to find more favourite patterns.",
  "nav.filters": "Filters",
  "nav.invitationh1": "We will help you find the pattern you think about.",
  "nav.invitationp1": "Sewing patterns from individual designers from EUR 5",
  "nav.invitationinput": "What do you want to sew?",
  "nav.invitationpbutton": "See all patterns",
  "nav.invitationabutton": "Sell all new arrivals",
  "nav.patterndescription": "Product description",
  "nav.sizetables": "Size tables",
  "nav.additionalinformation": "Additional information",
  "nav.patterns": "Patterns",
  "nav.reviews": "Reviews",
  "nav.headingTitleDHP":
    "Sell your own tailor patterns and have time to creating new ones",
  "nav.bodytitleDHP":
    "You are passionate about sewing, a recognizable designer - decide for yourself the price for patterns, earn as much as you want.",
  "nav.startSellingPatterns": "Start selling patterns",
  "nav.headingInvitationDHP": "See what you get with Sewlight",
  "nav.bodyInvitationDHP": "Discover all the benefits of working with us",
  "nav.headingHowIsDHP": "How it is working?",
  "nav.bodyHowIsDHP": "start the adventure in 5 easy steps",
  "nav.headingHelpDHP": "We are here to help",
  "nav.bodyHelpDHP":
    "If you have any questions or need help, please contact with us ;D",
  "nav.headingStartSell": "Start selling your patterns!",
  "nav.bodyStartSell":
    "Register and start making more on your patterns how much do you want. Set a price, we will take care of the rest :D",
  "nav.support": "Support",
  "nav.signup": "Signup",
  "nav.favorites": "Favorites",
  "nav.cart": "Cart",
  "nav.purchaseHistory": "Purchase history",
  "nav.search": "Search",
  "nav.contact": "Contact",
  "nav.sellYourPatterns": "Sell your patterns",
  "footer.brand.subtitle": "Digital sewing patterns marketplace",
  "footer.links.title": "Links",
  "footer.links.privacyPolicy": "Privacy Policy",
  "footer.links.platformTerms": "Platform Terms",
  "footer.links.creatorTerms": "Creator Terms",
  "footer.links.newsletterTerms": "Newsletter Terms",
  "footer.support.title": "Support",
};

const site = {
  "site.goBack": "Go Back",
  "site.buyNow": "Buy now",
  "site.imageUpload.removeImage": "Remove Image",
  "site.imageUpload.chooseImage": "Choose Image",
  "site.imageUpload.fileSizeTooBig": "File size is too big",
  "site.imageUpload.uploadLabel":
    "Max file size: 8mb, accepted: jpg | gif | png | jpeg | webp",
  "site.manageProfile.createProfile": "Create Profile",
  "site.manageProfile.editProfile": "Edit Profile",
  "site.spinner.loading": "Loading",
  "site.logout": "Logout",
  "site.login": "LogIn",
  "site.forgottenPassword": "Forgotten password",
  "site.noAccount": "No account yet",
  "site.specification.lastUpdate": "Last update",
  "site.patternDescription.tab1": "Product description",
  "site.patternDescription.tab2": "Additional information",
  "site.previous": "Previous",
  "site.next": "Next",
  "site.yes": "Yes",
  "site.no": "No",
  "site.hello": "Hello",
  "site.addToFavourites": "Add to favourites",
  "site.removeFromFavourites": "Remove from favourites",
  "site.users": "users",
  "site.products": "products",
  "site.orders": "orders",
  "site.manageUser": "Manage user",
  "site.removeUser": "Remove user",
  "site.reviews.noReviews": "No reviews yet",
  "site.commentForm.placeholder": "Comment here",
  "site.comments.notLoggedInComments": "Please log in to write a review",
  "site.reviews.reviewSubmitted": "Review submitted",
  "site.comments.leaveComment": "Leave a comment",
};

const contact = {
  "contact.title": "Get in Touch",
  "contact.subtitle": "We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
  "contact.form.title": "Send us a Message",
  "contact.form.success.title": "Message Sent!",
  "contact.form.success.message": "Thank you for contacting us. We'll get back to you soon.",
  "contact.form.name": "Your Name",
  "contact.form.name.placeholder": "John Doe",
  "contact.form.email": "Email Address",
  "contact.form.email.placeholder": "john@example.com",
  "contact.form.subject": "Subject",
  "contact.form.subject.placeholder": "How can we help you?",
  "contact.form.message": "Message",
  "contact.form.message.placeholder": "Tell us more about your inquiry...",
  "contact.form.submit": "Send Message",
  "contact.info.title": "Contact Information",
  "contact.info.email.label": "Email",
  "contact.info.phone.label": "Phone",
  "contact.info.hours.label": "Business Hours",
  "contact.info.hours.value": "Mon - Fri: 9:00 AM - 6:00 PM",
  "contact.info.location.label": "Location",
  "contact.info.location.value": "Warsaw, Poland",
  "contact.social.title": "Follow Us",
};

const page404 = {
  "page404.message": "Oops. We couldn't find that page. Go back to the previous page or return home.",
  "page404.backButton": "Go back to the previous page",
  "page404.homeButton": "Return to homepage",
};

const dashboard = {
  "dashboard.title": "My patterns",
  "dashboard.noProfile.title": "Welcome! Let's Get Started",
  "dashboard.noProfile.message": "You haven't set up your designer profile yet. Create your profile to start selling your amazing patterns and connect with customers around the world!",
  "dashboard.noProfile.button": "Create Your Profile",
  "dashboard.patterns.error.title": "Failed to load your patterns",
  "dashboard.patterns.empty.title": "You have no patterns yet",
  "dashboard.patterns.empty.message": "Add your first pattern to have it shown here.",
  "dashboard.patterns.filtered.empty.title": "No patterns match your filters",
  "dashboard.patterns.filtered.empty.message": "Change filters to see your patterns.",
  "dashboard.patterns.search.placeholder": "Search my patterns",
  "dashboard.profileActions.editProfile": "Edit profile",
  "dashboard.profileActions.addPattern": "Add pattern",
  "dashboard.profileActions.designStudio": "Design in Studio",
};

const comments = {
  "comments.submit": "Submit comment",
};

const login = {
  "login.placeholder.email": "Login/e-mail",
  "login.placeholder.password": "Password",
};

const patternGrid = {
  "patternGrid.noPatternsTitle": "No Patterns Found",
  "patternGrid.noPatternsMessage": "You haven’t created any patterns yet. Start by adding your first pattern.",
  "patternGrid.createPattern": "Create Pattern",
};

const header = {
  "header.toggleMenu": "Toggle menu",
  "header.search": "Search",
};

const sidebar = {
  "sidebar.profileNavigation": "Profile navigation",
};

const hero = {
  "hero.slide1.headline": "What will you sew today?",
  "hero.slide1.subtitle": "Find the pattern that’s on your mind",
  "hero.slide2.headline": "We sew good news!",
  "hero.slide2.subtitle": "Sign up for the newsletter and receive inspiration, news, and special offers from creators",
  "hero.slide3.headline": "Sell patterns and grow your brand",
  "hero.slide3.subtitle": "Focus on designing, we’ll take care of the rest",
  "hero.previousSlide": "Previous slide",
  "hero.nextSlide": "Next slide",
  "hero.learnMore": "Learn more",
};

const cart = {
  "cart.goToyourCart": "Go to your cart",
  "cart.addToCart": "Add to cart",
  "cart.addedToCart.single": "Added to cart: {size}",
  "cart.addedToCart.multiple": "Added sizes to cart: {sizes}",
  "payment.method.title": "Payment Method",
  "payment.method.paypalLabel": "PayPal or Credit Card",
  "payment.method.stripeLabel": "Stripe",
  "payment.continue": "Continue",
  "placeOrder.title": "Place order",
  "placeOrder.paymentMethod.title": "Payment method",
  "placeOrder.paymentMethod.value": "Method: {method}",
  "placeOrder.cartEmpty": "Your cart is empty",
  "placeOrder.order.title": "Order",
  "placeOrder.by": "By",
  "order.card.items": "Total items: {count}",
  "order.card.totalPriceLabel": "Total price: {price}",
  "patterns.header.backToProfiles": "Back to profiles",
  "cart.allSizesAlreadyInCart": "All sizes of this pattern are already in cart",
  "cart.selectAtLeastOneSize": "Please select at least one size",
  "cart.alreadyInCart": "This pattern is already in your cart",
  "cart.copyLinkSuccess": "Copied the product link",
  "cart.copyLinkFailed": "Failed to copy link. Please copy the address from your browser.",
  "cart.addedToFavourites": "Added to favourites",
  "cart.removedFromFavourites": "Removed from favourites",
  "cart.title": "Your basket",
  "cart.patterns": "patterns",
  "cart.tableTitle.pattern": "pattern",
  "cart.pay": "Pay",
  "cart.tableTitle.name": "name",
  "cart.tableTitle.size": "size",
  "cart.tableTitle.price": "price",
  "cart.tableTitle.totalPice": "Total price",
  "cart.tableTitlecart.removeFromCart": "Remove pattern from your cart",
  "cart.total": "Total",
  "cart.summary": "Summary",
  "cart.tableTitle.removeFromList": "Remove from list",
  "cart.favourites": "Favourites",
  "cart.tableTitlefavourites.removeFromList": "Remove from favourites",
  "cart.tableTitlecart.removeFromList": "Remove pattern from your cart",
  "cart.apply": "Apply",
  "cart.promoCode.heading": "Have a promo code?",
  "cart.promoCode.placeholder": "Enter code",
  "cart.toast.applyingPromo": "Applying promo...",
  "cart.promoCode.applied": "✓ {code} applied",
  "cart.promoCode.discountPercentage": "{value}% off",
  "cart.promoCode.discountAmount": "{value} off",
  "cart.promoCode.appliesTo": "Applies to {count, plural, one {# item} other {# items}}",
  "cart.promoCode.fromCreator": "from {creator}",
  "cart.discount": "Discount ({code})",
  "cart.subtotal": "Subtotal ({count, plural, one {# item} other {# items}})",
  "cart.remove": "Remove",
  "cart.unknownSeller": "Unknown",
  "cart.omnibusInfo": "Lowest price in 30 days before discount: {price}",
  "cart.sizePicker.title": "Select size",
  "cart.sizePicker.description": "Choose the pattern size you want to add to cart.",
  "cart.sizePicker.confirm": "Add to cart",
  "cart.sizePicker.cancel": "Cancel",
  "cart.changeSize": "Change size",
};

const sizes = {
  "categories.sizes.title": "Size",
  "categories.sizes.xxs": "XXS",
  "categories.sizes.xs": "XS",
  "categories.sizes.s": "S",
  "categories.sizes.m": "M",
  "categories.sizes.l": "L",
  "categories.sizes.xl": "XL",
  "categories.sizes.xxl": "XXL",
  "categories.sizes.xxxl": "XXXL",
  "categories.sizes.onesize": "One size",
};

// Categproes intl
const pattern = {
  "pattern.editPattern": "Edit pattern",
  "pattern.addPattern": "Add new pattern",
  "pattern.draftDesign": "Draft design",
  "pattern.difficulty.label": "Difficulty level",
  "pattern.difficulty.easy": "Easy",
  "pattern.difficulty.medium": "Medium",
  "pattern.difficulty.hard": "Hard",
  "pattern.yourpatterns.title": "Your patterns",
  "pattern.removePattern.areYouSure":
    "Would you really like to remove this pattern?",
};

const client = {
  "categories.clients.title": "For who",
  "categories.clients.female": "Female",
  "categories.clients.male": "Male",
  "categories.clients.girl": "Girl",
  "categories.clients.boy": "Boy",
  "categories.clients.infant": "Infant",
  "categories.clients.unisex": "Unisex",
};
const categories = {
  "categories.sizes.title": "Size",
  "categories.categories.title": "Category",
  "categories.categories.dresses": "Dresses",
  "categories.categories.skirts": "Skirts",
  "categories.categories.trousers": "Trousers",
  "categories.categories.blouses": "Blouses",
  "categories.categories.shirts": "Shirts",
  "categories.categories.tshirts": "T-shirts",
  "categories.categories.sweaters": "Sweaters",
  "categories.categories.cardigans": "Cardigans",
  "categories.categories.jackets": "Jackets and Vests",
  "categories.categories.shorts": "Shorts",
  "categories.categories.newArrivals": "New arrivals",
  "categories.categories.all": "All categories",
  "categories.page.titleAll": "All categories",
  "categories.page.sliderCategoryAll": "all categories",
  "nav.thumpnailsDesignerTitle": "Top rated designers in the category of {category}",
};

const fabrics = {
  "categories.fabrics.title": "Recommended fabric",
  "categories.fabrics.cotton": "Cotton",
  "categories.fabrics.flannel": "Flannel",
  "categories.fabrics.linen": "Linen",
  "categories.fabrics.fleece": "Fleece",
  "categories.fabrics.canvas": "Canvas",
  "categories.fabrics.muslin": "Muslin",
  "categories.fabrics.precuts": "Precuts",
  "categories.fabrics.stretch": "Stretch",
  "categories.fabrics.rayon": "Rayon",
  "categories.fabrics.silk": "Silk",
  "categories.fabrics.wool": "Wool",
  "categories.fabrics.other": "Other",
};

const order = {
  "order.card.title": "Order summary",
  "order.card.finalize": "Place an order",
  "order.summary.isPaid": "Order completed",
  "order.summary.isNotPaid": "Not paid",
  "order.summary.title": "Order {orderId}",
  "order.summary.orderHeading": "Order",
  "order.summary.payWithStripe": "Pay with Stripe",
  "order.summary.stripeError": "Stripe error",
  "order.summary.paymentUnknown": "Unknown payment error",
  "order.summary.paymentMethod": "Payment method",
  "order.list.titleId": "Order ID",
  "order.list.date": "Date",
  "order.list.total": "Total",
  "order.list.paymentStatus": "Payment status",
  "order.list.paid": "Completed",
  "order.list.unpaid": "Not paid",
  "order.list.buttonDetails": "Details",
  "order.history.title": "Purchase history",
  "order.history.period.label": "Range",
  "order.history.period.last30": "Last 30 days",
  "order.history.period.last90": "Last 90 days",
  "order.history.period.last180": "Last 180 days",
  "order.history.period.last365": "Last 365 days",
  "order.history.period.all": "All",
  "order.history.empty": "No orders in selected period.",
  "order.history.columns.orderNumber": "Order number",
  "order.history.columns.product": "Product",
  "order.history.columns.name": "Name",
  "order.history.columns.size": "Size",
  "order.history.columns.date": "Date",
  "order.history.columns.price": "Price",
  "order.history.columns.paymentType": "Payment type",
  "order.history.columns.status": "Status",
  "order.history.year.label": "Year",
  "order.history.range.label": "Date range",
  "order.history.range.startAria": "Date range start",
  "order.history.range.endAria": "Date range end",
  "order.history.statusFilter.label": "Filter by status",
  "order.history.statusFilter.all": "All",
  "order.history.statusFilter.paid": "Completed",
  "order.history.statusFilter.cancelled": "Cancelled",
  "order.history.applyFilters": "Apply",
  "order.history.action.cancel": "Cancel",
  "order.history.dateRange.select": "Select date range",
  "order.history.loadMore.default": "Show more",
  "order.history.loadMore.loading": "Loading...",
  "order.history.showId": "Show full ID",
  "order.history.hideId": "Hide ID",
  "order.history.copyId": "Copy ID",
  "order.history.copied": "Copied",
  "order.history.status.paid": "Completed",
  "order.history.status.cancelled": "Cancelled",
  "order.history.downloadPattern.title": "Download Pattern",
  "order.history.downloadPattern.close": "Close",
  "order.history.downloadPattern.availableFiles": "Available Files ({count})",
  "order.history.downloadPattern.pdfDocument": "PDF Document",
  "order.history.downloadPattern.download": "Download",
  "order.history.downloadPattern.loadingPdf": "Loading PDF...",
  "order.history.downloadPattern.failedToLoadPdf": "Failed to load PDF.",
  "order.history.downloadPattern.selectFilePreview": "Select a file to preview",
  "order.history.downloadPattern.downloadAll": "Download All",
  "order.history.reason.paymentFailedFallback":
    "Payment was declined or cancelled.",
  "order.history.reason.paymentUnknownFallback":
    "Payment status is not confirmed.",
  "order.history.paymentType.cardStripe": "Card (Stripe)",
};

const patternStudio = {
  "patternStudio.menu.button": "Menu",
  "patternStudio.menu.saveProject": "Save Project",
  "patternStudio.menu.exportToPDF": "Export to PDF",
  "patternStudio.menu.showGrid": "Show Grid",
  "patternStudio.menu.hideGrid": "Hide Grid",
  "patternStudio.menu.moreComingSoon": "More (coming soon)",
  "patternStudio.toolbar.undo": "Undo (Ctrl+Z)",
  "patternStudio.toolbar.redo": "Redo (Ctrl+Y)",
  "patternStudio.toolbar.undoLabel": "Undo",
  "patternStudio.toolbar.redoLabel": "Redo",
  "patternStudio.unit.px": "Pixels",
  "patternStudio.unit.cm": "cm",
  "patternStudio.unit.in": "Inches",
  "patternStudio.canvas.label": "Canvas",
  "patternStudio.canvas.width": "Width",
  "patternStudio.canvas.height": "Height",
  "patternStudio.snapGrid": "Snap Grid",
  "patternStudio.tool.select": "Select",
  "patternStudio.tool.hand": "Hand",
  "patternStudio.tool.pen": "Pen",
  "patternStudio.tool.bezierCurve": "Bezier Curve",
  "patternStudio.tool.bezierPenTitle": "Bézier Pen — click to place anchors (Enter to finish, Esc to cancel)",
  "patternStudio.tool.rectangle": "Rectangle",
  "patternStudio.tool.circle": "Circle",
  "patternStudio.tool.line": "Line",
  "patternStudio.tool.text": "Text",
  "patternStudio.properties.title": "Properties",
  "patternStudio.properties.type": "Type",
  "patternStudio.properties.x": "X",
  "patternStudio.properties.y": "Y",
  "patternStudio.properties.width": "Width",
  "patternStudio.properties.height": "Height",
  "patternStudio.properties.radius": "Radius",
  "patternStudio.properties.length": "Length",
  "patternStudio.properties.smoothing": "Smoothing",
  "patternStudio.properties.strokeColor": "Stroke Color",
  "patternStudio.properties.strokeWidth": "Stroke Width",
  "patternStudio.properties.delete": "Delete",
  "patternStudio.bezier.type": "Type: Bézier Pen Path",
  "patternStudio.bezier.anchors": "Anchors: {count}",
  "patternStudio.bezier.closePath": "Close Path",
  "patternStudio.emptyState.zoomLabel": "Zoom",
  "patternStudio.emptyState.gridLabel": "Grid",
  "patternStudio.layers.title": "Layers",
  "patternStudio.layers.selected": "selected",
  "patternStudio.layers.bezierLabel": "Bézier #{index}",
};

const admin = {
  "admin.userList.title": "Users",
  "admin.dashboard.title": "Dashboard",
  "admin.patternList.title": "Patterns",
  "admin.orderList.title": "Orders",
  "admin.patternList.createPattern": "Create Pattern",
  "admin.patternList.empty": "No patterns found.",
  "admin.list.titleId": "ID",
  "admin.list.name": "Name",
  "admin.list.email": "Email",
  "admin.list.user": "user",
  "admin.list.isAdmin": "Has admin rights",
  "admin.list.notAdmin": "Has no admin rights",
  "admin.list.user.removed": "Deleted",
  "admin.list.actions": "Actions",
  "admin.list.user.active": "Active",
  "admin.list.isPaid": "Is Paid",
  "admin.list.user.deletedOn": "Deleted on {date}",
  "admin.adminList.confirmTitle":
    "Are you sure you want to delete this pattern?",
  "admin.adminList.confirmUserDelete":
    "Are you sure you want to delete that user?",
  "admin.login.title": "Admin login",
  "admin.login.subtitle": "Admin access only",
  "admin.login.emailLabel": "Email",
  "admin.login.emailPlaceholder": "admin@example.com",
  "admin.login.passwordLabel": "Password",
  "admin.login.passwordPlaceholder": "••••••••",
  "admin.login.button": "Log in",
  "admin.login.loading": "Logging in...",
  "admin.sidebar.stats": "Stats",
  "admin.sidebar.users": "Users",
  "admin.sidebar.orders": "Orders",
  "admin.sidebar.patterns": "Patterns",
  "admin.sidebar.settings": "Settings",
  "admin.sidebar.backToHome": "Back to Home",
  "admin.sidebar.logout": "Log out",
  "admin.settings.title": "Settings",
  "admin.settings.sectionCommission": "Commission",
  "admin.settings.labelCommissionRate": "Commission rate (%)",
  "admin.settings.placeholderCommissionRate": "e.g. 1",
  "admin.settings.saved": "Saved",
  "admin.settings.buttonUpdateCommission": "Update commission",
  "admin.stats.sectionOrders": "Orders",
  "admin.stats.sectionPatterns": "Patterns",
  "admin.stats.sectionUsers": "Users",
  "admin.stats.orders.total": "Total",
  "admin.stats.orders.creator": "Creator",
  "admin.stats.orders.site": "Site",
  "admin.stats.orders.totalRevenue": "Total Revenue",
  "admin.stats.orders.creatorRevenue": "Creator Revenue",
  "admin.stats.orders.siteRevenue": "Site Revenue",
  "admin.stats.orders.commissionRate": "Commission Rate",
  "admin.stats.orders.platformCut": "Platform cut",
  "admin.stats.orders.revenueBreakdown": "Revenue Breakdown",
  "admin.stats.orders.revenueSplit": "Revenue Split",
  "admin.stats.orders.topOrders": "Top Orders",
  "admin.stats.orders.user": "User",
  "admin.stats.orders.amount": "Amount",
  "admin.stats.orders.date": "Date",
  "admin.stats.patterns.avgPrice": "Avg Price",
  "admin.stats.patterns.totalPatterns": "Total Patterns",
  "admin.stats.patterns.averagePrice": "Average Price",
  "admin.stats.patterns.topPatternSales": "Top Pattern Sales",
  "admin.stats.patterns.atGlance": "Patterns at a Glance",
  "admin.stats.patterns.top5BySales": "Top 5 Patterns by Sales",
  "admin.stats.patterns.topPatterns": "Top Patterns",
  "admin.stats.patterns.patternName": "Pattern Name",
  "admin.stats.patterns.totalSales": "Total Sales",
  "admin.stats.patterns.orders": "Orders",
  "admin.stats.patterns.avgSale": "Avg. Sale",
  "admin.stats.users.totalUsers": "Total Users",
  "admin.stats.users.creators": "Creators",
  "admin.stats.users.customers": "Customers",
  "admin.stats.users.banned": "Banned",
  "admin.stats.users.breakdown": "User Breakdown",
  "admin.stats.users.typeCounts": "User Type Counts",
  "admin.stats.users.topCustomers": "Top Customers",
  "admin.stats.users.name": "Name",
  "admin.stats.users.totalSpent": "Total Spent",
  "admin.stats.users.avgOrder": "Avg. Order",
  "creator.sidebar.dashboard": "Dashboard",
  "creator.sidebar.orders": "Orders",
  "creator.sidebar.finance": "Finance",
  "creator.sidebar.analytics": "Analytics",
  "creator.sidebar.promotions": "Promotions",
  "creator.sidebar.messages": "Messages",
  "creator.sidebar.settings": "Settings",
  "creator.sidebar.backToProfile": "Back to Profile",
  "creator.sidebar.backToHome": "Back to Home",
  "creator.sidebar.logout": "Log out",
};

const translations = {
  ...nav,
  ...contact,
  ...page404,
  ...dashboard,
  ...comments,
  ...login,
  ...patternGrid,
  ...header,
  ...sidebar,
  ...hero,
  ...categories,
  ...pattern,
  ...site,
  ...cart,
  ...client,
  ...fabrics,
  ...sizes,
  ...order,
  ...patternStudio,
  ...admin,
};

export default translations;
